module.exports = __webpack_public_path__ + "img/jxszs.7d33979a.png";